//action
import{
    UPDATE_DOCTOR_DETAIL,
    UPDATE_DOCTOR_DETAIL_FAIL,
    UPDATE_DOCTOR_DETAIL_SUCCESS,
    UPDATE_DOCTOR_DETAIL_RESET
} from "../action/updateDoctorDetailAction"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_DOCTOR_DETAIL:
            return {
                ...state,
                apiState: "loading"
            }
        case UPDATE_DOCTOR_DETAIL_FAIL:
            console.log("updatereducerfail")
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case UPDATE_DOCTOR_DETAIL_SUCCESS:
            console.log("upreducer",action.response)
            return {
                ...state,
                apiState: "success",
                data: action.response,
                message: action.response && action.response.data && action.response.data.message || api_err_msg
            }
        case UPDATE_DOCTOR_DETAIL_RESET:
            return initialState
        default:
            return state
        }
}